import { Component, Input } from '@angular/core';
import {
  WagtailPageContentElementInterface,
  WagtailSimpleTitleInterface
} from "@gea-waldviertler-website/gea-models";

@Component({
    selector: 'wagtail-page-element-shop-simple-title',
    templateUrl: './shop-simple-title.component.html',
    styleUrls: ['./shop-simple-title.component.scss'],
    standalone: false
})
export class ShopSimpleTitleComponent {

  @Input() definition?: WagtailPageContentElementInterface<WagtailSimpleTitleInterface>
  content?: WagtailSimpleTitleInterface

  ngOnInit(): void {
    if (this.definition) {
      this.content = this.definition.value
    }
  }
}
